var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FieldItem",
    { attrs: { id: _vm.id, label: _vm.$t(_vm.fieldConfig.label) } },
    [
      _c(
        "template",
        { slot: "label" },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t(_vm.fieldConfig.label)))]),
          _c(
            "ElPopover",
            {
              attrs: {
                "visible-arrow": false,
                width: 366,
                placement: "right",
                trigger: "hover",
                "popper-class": "bio-search-setting__popover",
              },
            },
            [
              _c("AlgorithmPopover", {
                attrs: { options: _vm.store.algorithmOptions },
              }),
              _c("PtIcon", {
                attrs: { slot: "reference", icon: "SolidInfo" },
                slot: "reference",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.store.algorithmOptions.length > 1
            ? _c(
                "ElSelect",
                {
                  staticClass: "search-preference__select",
                  attrs: {
                    size: "small",
                    placeholder: _vm.$t(_vm.fieldConfig.label),
                    disabled: _vm.store.settingValues.automatic,
                  },
                  on: { change: _vm.onChange },
                  model: {
                    value: _vm.fieldValue,
                    callback: function ($$v) {
                      _vm.fieldValue = $$v
                    },
                    expression: "fieldValue",
                  },
                },
                [
                  _vm._l(_vm.store.algorithmOptions, function (option) {
                    return [
                      !(_vm.store.isShort && option.value === "megablast")
                        ? _c("ElOption", {
                            key: option.value,
                            attrs: { label: option.label, value: option.value },
                          })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              )
            : _c("span", { staticClass: "search-preference__optionText" }, [
                _vm._v(" " + _vm._s(_vm.displayValue) + " "),
              ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }